var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex justify-start flex-column numberInput" },
    [
      _c(
        "v-sheet",
        { staticClass: "text--secondary d-inline-block text-truncate" },
        [
          _vm.showLabel
            ? _c("span", { class: _vm.labelClass }, [_vm._v(_vm._s(_vm.label))])
            : _vm._e(),
        ]
      ),
      _c("v-text-field", {
        staticClass: "text-center",
        attrs: {
          filled: _vm.filled,
          "single-line": _vm.singleLine,
          hint: _vm.hint,
          height: _vm.height,
          maxlength: _vm.maxlength,
          type: _vm.filled ? _vm.type : "text",
          "prepend-inner-icon": _vm.filled ? "mdi-minus" : "",
          "append-icon": _vm.filled ? "mdi-plus" : "",
          rules: _vm.canFocus ? _vm.rules : [],
          dense: _vm.dense,
          error: _vm.isError,
          "error-messages": _vm.errorMsg,
          disabled: _vm.disabled,
          readonly: _vm.readonly,
        },
        on: {
          input: _vm.changeNumber,
          "click:prepend-inner": function ($event) {
            _vm.filled ? _vm.minus() : null
          },
          "click:append": function ($event) {
            _vm.filled ? _vm.plus() : null
          },
          focus: function ($event) {
            _vm.focus = true
            _vm.canFocus = true
          },
          blur: function ($event) {
            _vm.focus = false
            _vm.changeNumber()
          },
        },
        model: {
          value: _vm.curValue,
          callback: function ($$v) {
            _vm.curValue = $$v
          },
          expression: "curValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }